/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/*
These column validators accept a column value and run a true/ false test over them. In order to make them
easy to reason about in a true/ false fashion rather than having an falsey empty string be good and an
truthy error message string indicate failure, let's abuse JavaScript and stick an .error_message property
on the functions. It might be ugly, but it scales for any future meta data the validators may need to provide.
Error messages are of the format ' stuff went wrong' with the assumption the caller will prefix the field name.
*/

export const isNotEmpty = value => value != null && ("" + value).trim().length > 0
isNotEmpty.error_message = "must be completed"

export const isNumberOrNull = value => value == null || isNumber(value)
isNumberOrNull.error_message = "is not a valid number"

export const isNumber = value => typeof value === "number" && !isNaN(value)
isNumber.error_message = "is not a valid number"

export const isInteger = value => Number.isInteger(value)
isInteger.error_message = "is not a valid integer"

export const isIntegerOrNull = value => value == null || Number.isInteger(value)
isIntegerOrNull.error_message = "is not a valid integer"

// note: by itself this will pass blank values as true
export const isValidEmail = value => {
    if (!value) {
        return true
    }
    value = value.trim()
    return value === "" || /^\S+@\S+\.\S+$/.test(value)
}
isValidEmail.error_message = "is not a valid email"

//making this a separate check in order to give a specific message
export const isLowercaseEmail = value => {
    if (!value) {
        return true
    }
    return /^[^A-Z]*$/.test(value)
}
isLowercaseEmail.error_message = "should be lowercase"

export const validateTimekeepingEntries = data => {
    let total_time = 0
    const time_fields = ["adjusted_minutes_st", "adjusted_minutes_dt", "adjusted_minutes_ot"]
    for (const key of time_fields) {
        if (data[key]) {
            total_time += data[key]
        }
        if (!isNumber(data[key])) data.errors[key] = ["Only numeric values allowed"]
    }
    // row-level validation: don't try to save if no time has been added
    if (total_time === 0) {
        data.alerts["/adjusted_minutes_st"] = ["Nonzero time is required"]
        data.alerts["/adjusted_minutes_ot"] = ["Nonzero time is required"]
        data.alerts["/adjusted_minutes_dt"] = ["Nonzero time is required"]
    }

    return data
}

export const validateUniqueEntry = (data, columnData = [], field, dataGridId) => {
    return columnData.every(entry => {
        if (entry.gridId === dataGridId || !data || !entry[field]) {
            return true
        }
        // TODO: this needs to use a valueGetter to work properly with nested fields (and other situations).
        // However, since this is hard-coded to be set on all auto-generated columns for equipment and materials,
        // fixing this will break some shift extra functionality. We'll need to rework this feature.
        return entry[field].id !== data.id
    })
}

validateUniqueEntry.error_message = "is already added"

export const isNumberEqualGreaterThanMin = (...args) => {
    // this was the clearest way to spell out the args coming into the validators - only using value and cellParams
    const [value, allRowData, field, gridId, data, cellParams] = args
    const { min } = cellParams ?? {}
    return isNumber(value) && isNumber(min) ? value >= min : true
}
isNumberEqualGreaterThanMin.error_message = "does not meet minimum value"

export const isNumberEqualLessThanMax = (...args) => {
    // this was the clearest way to spell out the args coming into the validators - only using value and cellParams
    const [value, allRowData, field, gridId, data, cellParams] = args
    const { max } = cellParams ?? {}
    return isNumber(value) && isNumber(max) ? value <= max : true
}
isNumberEqualLessThanMax.error_message = "exceeds maximum value"
